<template>
  <div class="ems-page shift-page" data-test-id="shift-page">
    <navbar v-if="showNavbar" :back="backToSettings" :done="doneAndBackToHome"></navbar>
    <b-container class="mt-4">
      <b-row>
        <b-col>
          <div class="auto-logout-header" data-test-id="shift-header">Choose time shift ends</div>
        </b-col>
      </b-row>
      <b-row>
        <b-col class="mb-4">
          <b-button
            block
            class="auto-logout-button"
            variant="light"
            data-test-id="shift-auto-logout-button"
            @click="toggleAutoLogout"
          >
            <div class="auto-logout-button__text">Auto Logout</div>
            <div class="auto-logout-button__switch" @click.stop="() => {}">
              <b-form-checkbox v-model="autoLogoutOn" switch />
            </div>
          </b-button>
        </b-col>
      </b-row>
      <b-row>
        <b-col class="mb-4">
          <b-collapse id="my-collapse" v-model="autoLogoutOn">
            <b-form-timepicker
              v-model="autoLogoutTime"
              locale="en"
              data-test-id="shift-auto-logout-timepicker"
            ></b-form-timepicker>
          </b-collapse>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <div class="auto-logout-footer" data-test-id="shift-helper-message">
            Choose the time your shift ends to let the app automatically log you out.
          </div>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import { mapActions } from "vuex";

import Navbar from "@/Shift/components/navbar.vue";
import { getAutoLogoutTime, getSuggestedAutoLogoutTime } from "@/Shift/services/shift.service";

export default {
  name: "Settings",

  components: { Navbar },

  props: {
    showNavbar: {
      default: true,
      type: Boolean,
    },
  },

  data() {
    return {
      autoLogoutOn: false,
      autoLogoutTime: null,
    };
  },

  mounted() {
    this.autoLogoutTime = getAutoLogoutTime();

    if (this.autoLogoutTime !== null) {
      this.autoLogoutOn = true;
    }
  },

  beforeDestroy() {
    this.done();
  },

  methods: {
    ...mapActions("Login", ["setAutoLogout"]),

    backToSettings() {
      this.$router.push({ name: "start" });
    },

    done() {
      if (this.autoLogoutOn === false) {
        this.autoLogoutTime = null;
      }

      this.setAutoLogout(this.autoLogoutTime);
    },

    doneAndBackToHome() {
      this.done();
      this.backToSettings();
    },

    toggleAutoLogout() {
      this.autoLogoutOn = !this.autoLogoutOn;

      if (this.autoLogoutOn === false) {
        this.autoLogoutTime = null;

        return;
      }

      if (this.autoLogoutTime === null) {
        this.autoLogoutTime = getSuggestedAutoLogoutTime();
      }
    },
  },
};
</script>

<style scoped>
.shift-page {
  text-align: left;
}

.auto-logout-header {
  color: #dddddd;
  font-size: 0.9rem;
  margin-bottom: 1rem;
  text-transform: uppercase;
}

.auto-logout-button {
  display: flex;
}

.auto-logout-button__switch {
  margin-left: auto;
}

.auto-logout-footer {
  color: #dddddd;
  font-size: 0.9rem;
}
</style>
